<div *ngIf="!sendOtp" class="text-center login_center">
  <div class="form-signin">
    <div class="radius_border text-left">
      <img
        alt=""
        class="mb-4"
        style="height: 3rem"
        src="../../../assets/img/new-logo.png"
      />
      <div class="container">
        <div>
          A 6-digit code has been sent to {{ email }}. Enter the code to reset
          your password.
        </div>

        <div class="tab-content mt-4" id="pills-tabContent">
          <div>
            <div class="otp_section">
              <ng-otp-input
                #ngOtpInput
                (onInputChange)="onOtpChange($event)"
                *ngIf="showOtpComponent"
                [config]="config"
              ></ng-otp-input>
            </div>

            <div class="row">
              <div class="mt-3">
                <button
                  [disabled]="enableOtp"
                  (click)="otpOnSubmit()"
                  class="btn btn-primary"
                  style="background-color: rgb(74, 11, 119)"
                >
                  Reset password
                </button>
                <button
                  *ngIf="timeLeft === 0"
                  (click)="resendOtp()"
                  class="btn btn-primary ms-2"
                  style="background-color: rgb(74, 11, 119)"
                >
                  Resend OTP
                </button>
                <div class="font-weight-bold mt-3 cursor">
                  <span class="resend-otp">Resend OTP </span>
                  <span class="resend-otp-timer"> in {{ timeLeft }} Sec</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="sendOtp" class="text-center login_center">
  <div class="form-signin">
    <div class="radius_border text-left" style="min-width: 30rem">
      <img
        alt=""
        class="mb-4"
        style="height: 3rem"
        src="../../../assets/img/new-logo.png"
      />
      <br />
      <span style="font-size: medium"><b>Reset password</b></span>
      <div class="tab-content mt-4" id="pills-tabContent">
        <div>
          <form [formGroup]="passwordForm">
            <div class="form-floating mb-5">
              <label class="password_title" for="password">New Password</label>
              <input
                #input
                class="form_style field_styles mt-5"
                formControlName="password"
                id="password"
                placeholder="Password"
                type="password"
                pInputText
                [ngClass]="{
                  'is-invalid':
                    submittedPassword &&
                    passwordForm.controls['password'].errors
                }"
                (change)="onPasswordChange()"
              />
              <div
                class="text-right"
                style="margin-top: -1.5rem; padding-right: 1rem"
              >
                <i
                  style="color: rgb(2 0 31 / 49%);position: relative;bottom: 0.3rem;"
                  [ngClass]="icontoDisplay"
                  (click)="toggleFieldTextType(input)"
                ></i>
              </div>

              <p
                class="error_message"
                *ngIf="passwordForm.controls['password'].errors?.['pattern']"
              >
                Must contain at least one number,one special <br />
                character, one uppercase and lowercase letter,<br />
                and at least 10 or more characters.
              </p>
            </div>

            <div class="form-floating mb-5">
              <label class="password_title" for="password"
                >Confirm New Password</label
              >
              <input
                #input1
                class="form_style field_styles mt-5"
                formControlName="confirmPassword"
                id="confirmPassword"
                placeholder="Confirm Password"
                type="password"
                pInputText
                [ngClass]="{
                  'is-invalid':
                    submittedPassword &&
                    passwordForm.controls['confirmPassword'].errors
                }"
                (change)="onPasswordChange()"
              />
              <div
                class="text-right"
                style="margin-top: -1.5rem; padding-right: 1rem"
              >
                <i
                  style="color: rgba(10, 31, 0, 0.49);position: relative;bottom: 0.3rem;"
                  [ngClass]="icontoDisplay1"
                  (click)="toggleFieldTextType1(input1)"
                ></i>
              </div>

              <p
                class="error_message"
                *ngIf="confirmPassword.hasError('mismatch')"
              >
                *Both passwords must match
              </p>
            </div>

            <div class="text-center">
              <button
                class="btn btn-primary"
                (click)="setNewPassword()"
                style="background-color: rgb(74, 11, 119)"
              >
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
